import _ from 'lodash';
import { combineReducers } from 'redux';
import { createSelector } from 'reselect';
import types from 'frontend/state/actionTypes';

const stateVersion = () => 35;

function versionReducer(state = null, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case types.FETCH_STATUS_SUCCESS:
      return _.get(payload, 'version.version', null);
    default:
      return state;
  }
}

function versionUpdatedReducer(state = null, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case types.FETCH_STATUS_SUCCESS:
      return _.get(payload, 'version.updated', null);
    default:
      return state;
  }
}

function gameDataVersionReducer(state = null, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case types.FETCH_STATUS_SUCCESS:
      return _.get(payload, 'version.gameData', null);
    default:
      return state;
  }
}

function initialVersionReducer(state = null) {
  return state;
}
function initialVersionUpdatedReducer(state = null) {
  return state;
}
function initialGameDataVersionReducer(state = null) {
  return state;
}

export default combineReducers({
  stateVersion,
  version: versionReducer,
  versionUpdated: versionUpdatedReducer,
  gameDataVersion: gameDataVersionReducer,
  initialVersion: initialVersionReducer,
  initialVersionUpdated: initialVersionUpdatedReducer,
  initialGameDataVersion: initialGameDataVersionReducer,
});

const baseSelector = state => state.version;
const stateVersionSelector = state => baseSelector(state).stateVersion;
const initialVersionSelector = state => baseSelector(state).initialVersion;
const initialVersionUpdatedSelector = state => baseSelector(state).initialVersionUpdated;
const initialGameDataVersionSelector = state => baseSelector(state).initialGameDataVersion;
const versionSelector = state => baseSelector(state).version;
const versionUpdatedSelector = state => baseSelector(state).versionUpdated;
const gameDataVersionSelector = state => baseSelector(state).gameDataVersion;
const newVersionAvailableSelector = createSelector(
  versionSelector,
  versionUpdatedSelector,
  gameDataVersionSelector,
  initialVersionSelector,
  initialVersionUpdatedSelector,
  initialGameDataVersionSelector,
  (version, versionUpdated, gameDataVersion, initialVersion, initialVersionUpdated, initialGameDataVersion) => {
    if (initialVersion && version && version !== initialVersion) {
      const initialTime = new Date(initialVersionUpdated).getTime();
      const currentTime = new Date(versionUpdated).getTime();
      return currentTime > initialTime;
    }
    if (initialGameDataVersion && gameDataVersion && initialGameDataVersion !== gameDataVersion) {
      return true;
    }
    return false;
  },
);

export const selectors = {
  version: versionSelector,
  stateVersion: stateVersionSelector,
  initialVersion: initialVersionSelector,
  initialGameDataVersion: initialGameDataVersionSelector,
  newVersionAvailable: newVersionAvailableSelector,
};
